import { TextField } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import { signedNumberRegex } from 'utils/validation';
import ReferenceRateEditor from './ReferenceRateEditor';
import FloatingRate from '../../../../../../models/data/FloatingRate';
const FloatingRateEditor = ({ value, onChange }) => {
    const [referenceRate, setReferenceRate] = React.useState(value?.referenceRate);
    const [margin, setMargin] = React.useState(value?.margin?.toString() ?? '');
    const set = React.useCallback((newValue) => {
        const newFloatingRate = newValue.referenceRate !== undefined && newValue.margin !== '' ?
            new FloatingRate({ referenceRate: newValue.referenceRate, margin: Number.parseFloat(newValue.margin) })
            : undefined;
        onChange({ target: { value: newFloatingRate } });
    }, [onChange]);
    const onChangeMargin = React.useCallback((event) => {
        const newValue = event.target.value;
        if (signedNumberRegex.exec(newValue) !== null) {
            setMargin(newValue);
            set({ margin: newValue, referenceRate });
        }
    }, [set, referenceRate]);
    const onChangeReferenceRate = React.useCallback((event) => {
        const newValue = event.target.value;
        setReferenceRate(newValue);
        set({ margin, referenceRate: newValue });
    }, [set, margin]);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(ReferenceRateEditor, { disabled: false, onChange: onChangeReferenceRate, value: referenceRate }),
        React.createElement("div", { style: { width: '5rem' } },
            React.createElement(TextField, { onChange: onChangeMargin, value: margin }))));
};
export default FloatingRateEditor;
